import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { createTagService } from 'src/api/tag'
import { createTagSuccess } from 'src/reducers/tag/action'
import { TAG_CREATE } from 'src/reducers/tag/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

function* createTagFlow(payload) {
  try {
    const { entity, callback, onError } = payload
    const response = yield call(createTagService, entity)
    yield put(createTagSuccess(response.data))
    yield put(operationSuccess())
    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
    // The success callback is what re-enables the dialog, so without this the Create button
    // would stay disabled after a duplicate-name error and the modal could not be retried.
    if (payload.onError) payload.onError(error)
  }
}

export default function* createTagWatcher() {
  while (true) {
    const action = yield takeMaybe(TAG_CREATE)
    const { payload } = action

    yield fork(generalSaga, createTagFlow, payload)
  }
}
